import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { UiModalNextReachoutDateProps } from "../../models/components/modal-next-reachout-date.model";
import ModalNextReachoutDateForm from "./ModalNextReachoutDateForm";

const UiModalNextReachoutDate = (props: UiModalNextReachoutDateProps) => {
	const { t } = useTranslation("common");

	return (
		<Dialog
			header={t("UI_COMPONENTS.MODAL_NEXT_REACHOUT_DATE.TITLE")}
			visible={props.isVisible}
			breakpoints={{ "960px": "75vw", "640px": "100vw" }}
			style={{ width: "70vw" }}
			modal={true}
			focusOnShow={false}
			draggable={false}
			closable={true}
			onHide={props.onCancel}
			baseZIndex={2000}
		>
			<ModalNextReachoutDateForm
				initialDate={props.initialDate}
				onCancel={props.onCancel}
				onComplete={props.onComplete}
			/>
		</Dialog>
	);
};

export default UiModalNextReachoutDate;
